import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Mobile bottom tab bar — the phone-first primary nav. Home now lives as an
// icon in the top-left of the header, so the bar carries the four remaining
// modes as equal tabs (a fifth slot is free for the future). Desktop uses the
// sidebar instead; this is hidden at md+.

const YouIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <circle cx="12" cy="8" r="3.5" /><path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" />
  </svg>
);
const LogIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0" /><path d="M12 18v3" />
  </svg>
);
const DataIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M4 20V4" /><path d="M4 20h16" /><path d="M8 16l4-6 3 3 5-8" />
  </svg>
);
const InsightsIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M12 3v2M12 19v2M5 12H3m18 0h-2M6 6 4.5 4.5M18 6l1.5-1.5" /><circle cx="12" cy="12" r="4" />
  </svg>
);

const Tab = ({ to, label, Icon, active }) => (
  <Link
    to={to}
    className={`flex flex-col items-center justify-start gap-1 pt-1.5 text-xs font-semibold transition-colors ${
      active
        ? 'text-primary-600 dark:text-primary-400'
        : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
    }`}
  >
    <Icon className={`w-6 h-6 ${active ? 'solar-glow' : ''}`} />
    {label}
  </Link>
);

const BottomNav = () => {
  const { pathname } = useLocation();
  const is = (p) => pathname === p;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-50 h-[84px] px-2 pt-2
                 grid grid-cols-4 items-start
                 bg-surface-card/95 dark:bg-black/95 backdrop-blur
                 border-t border-surface-border dark:border-surface-dark-border"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Primary"
    >
      <Tab to="/you" label="You" Icon={YouIcon} active={is('/you')} />
      <Tab to="/log" label="Log" Icon={LogIcon} active={is('/log')} />
      <Tab to="/data" label="Data" Icon={DataIcon} active={is('/data')} />
      <Tab to="/insights" label="Insights" Icon={InsightsIcon} active={is('/insights')} />
    </nav>
  );
};

export default BottomNav;
